import { render } from "./DefaultComponent.vue?vue&type=template&id=ffdd4142&scoped=true&ts=true"
import script from "./DefaultComponent.vue?vue&type=script&lang=ts"
export * from "./DefaultComponent.vue?vue&type=script&lang=ts"

import "./DefaultComponent.vue?vue&type=style&index=0&id=ffdd4142&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\RuZja\\Desktop\\Projects\\ruzja\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffdd4142"]])

export default __exports__